import { createClasses } from '../../theme/create-classes';

export const flagIconClasses = {
    root: createClasses('flag__icon__root'),
    img: createClasses('flag__icon__img'),
};
